import { useProviderHint } from "@/lib/payments/providerHint";

interface Props {
  className?: string;
  /** Fired when user opts into the Wave→Flutterwave manual fallback. */
  onChooseFallback?: () => void;
}

export function ProviderHint({ className = "", onChooseFallback }: Props) {
  const { label, fallbackCta, isWaveCountry } = useProviderHint();
  if (!label) return null;
  return (
    <div className={`mt-2 space-y-1 text-xs text-muted-foreground ${className}`}>
      <p>{label}</p>
      {isWaveCountry && fallbackCta && onChooseFallback && (
        <button
          type="button"
          onClick={onChooseFallback}
          className="underline underline-offset-2 hover:text-foreground"
        >
          {fallbackCta}
        </button>
      )}
    </div>
  );
}
